<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";

import moment from "moment";
import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'

export default {
  name: "TotalhoursWorked",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      employeeList: [],
      currentSorting: "",
      filterObj: {
        store_id: "",
        employee_id: "",
        to_date: "",
        from_date: ""
      }
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },

    getList(page) {
      this.list = [];
      this.currentPage = page;
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );
      this.$api
        .getAPI({
          _action:
            "/time_card/total_hours_worked/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list.map((employee) => {
              var total_hours = parseFloat(employee.total_hours);
              var hours = Math.floor(total_hours);
              var minutes = Math.round((total_hours - Math.floor(hours))*60);
              employee.total_hours = hours.toString() + " hours " + minutes.toString() + " minutes";
              employee.total_hours = `${hours.toString()} ${this.$lang.messages.hours.toLowerCase()} ${minutes.toString()} ${this.$lang.messages.minutes}`;
              return employee;
            });
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_record_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    getExport() {
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/time_card/export_total_hours/" +
          localStorage.getItem("client_id") +
          queryParam
      , _fileName: 'total_hours.csv'})
    },

    retry() {
      this.getList(1);
    }
  },
  mounted() {
    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-12 d-lg-flex justify-content-end">
          <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
            <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
          </div>

          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select v-model="filterObj.store_id" @change="getList(1) " class="form-control">
              <option value>{{$lang.messages.all_stores}}</option>
              <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
            </select>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
              <option value>{{$lang.messages.all_employees}}</option>
              <option
                v-for="employee in employeeList"
                :key="employee.id"
                :value="employee.id"
              >{{employee.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card rounded-5">
            <div class="pink-tape mt-2">
              <div class="row">
                <div class="col-lg-9 col-5 align-self-center">
                  <a
                    href="javascript:void(0)"
                    class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                    @click="getExport()">
                    {{$lang.messages.export}}
                    <i class="mdi mdi-download align-text-top"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="card-body table-responsive">
              <table class="table table-striped table-style-1">
                <thead>
                  <tr>
                    <th scope="col">Sr.no</th>
                    <th scope="col">{{$lang.messages.employees}}</th>
                    <th scope="col">{{$lang.messages.store}}</th>
                    <th scope="col" class="text-right">{{$lang.messages.total_hours}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,i) in list" :key="item.id">
                    <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                    <td>{{item.employee_name}}</td>
                    <td>{{item.store}}</td>
                    <td class="text-right">{{item.total_hours}}</td>
                  </tr>
                </tbody>
              </table>
              <ErrorComponent @retry="retry()" ref="errorComonent" />
            </div>
          </div>
          <div class="page-bottom-pagination text-right">
            <Pagination
              @page-change="pageChange"
              @items-per-page-change="itemsPerPageChange()"
              ref="listPagination"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
